import Link from 'next/link';
import styled from 'styled-components';
import { Fontw5s16h24 } from 'styles/commonCss';
import PrivacyLocale from 'locale/en/privacy.json';
import CcpaApplicantsLocale from 'locale/en/ccpa-notice-applicants.json';
import CcpaNoticeIndependentContractorsLocale from 'locale/en/ccpa-notice-independent-contractors.json';
import { mqLargeMin } from 'styled/tools/media-queries';

const SideNav = styled.ul`
  ${Fontw5s16h24}
  position: absolute;
  left: 0px;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  @media ${mqLargeMin} {
    left: 50px;
  }
`;

const SideNavItem = styled.li<{ underlined?: boolean }>`
  display: block;
  margin: 0;
  padding: 0;
  list-style: none;
  text-align: left;
  text-decoration: ${({ underlined }) => (underlined ? 'underline' : 'none')};
  a {
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const navItems = [
  {
    id: 1,
    href: '/privacy-policy',
    text: PrivacyLocale.page_title,
  },
  {
    id: 2,
    href: '/ccpa-notice-applicants',
    text: CcpaApplicantsLocale.page_title,
  },
  {
    id: 3,
    href: '/ccpa-notice-independent-contractors',
    text: CcpaNoticeIndependentContractorsLocale.page_title,
  },
];

const PrivacySideNav = ({ pageUrl }) => (
  <SideNav>
    {navItems.map((item) =>
      item.href === pageUrl ? (
        <SideNavItem key={item.id}>{item.text}</SideNavItem>
      ) : (
        <SideNavItem key={item.id} underlined>
          <Link prefetch={false} href={item.href}>
            {item.text}
          </Link>
        </SideNavItem>
      ),
    )}
  </SideNav>
);

export default PrivacySideNav;
